import React from 'react'
import { Wrapper } from '@googlemaps/react-wrapper'
import { Modal } from './VehicleMapModal.styled'
import MapWrapper from '../map-wrapper/MapWrapperContainer'

export interface IOwnProps {
  open: boolean
  onClose: () => void
  header: () => React.ReactNode,
}

export interface IStateProps {}

export interface IDispatchProps { }

export type IProps = IOwnProps & IStateProps & IDispatchProps

const VehicleMapModal: React.FC<IProps> = (props) => {
  const {
    open,
    onClose,
    header,
  } = props

  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY

  if (!apiKey) {
    // Fail closed rather than fall back to a key baked into source — every build
    // that ships without REACT_APP_GOOGLE_MAP_API_KEY set is a misconfiguration to
    // fix, not a case to silently paper over with a shared key.
    console.error('[VehicleMapModal] REACT_APP_GOOGLE_MAP_API_KEY is not set — map cannot load')
  }

  return (
    <Modal
      modalName='vehicleMap'
      open={open}
      onClose={onClose}
      header={header}
      isWideContent
    >
      {apiKey ? (
        <Wrapper apiKey={apiKey}>
          <MapWrapper/>
        </Wrapper>
      ) : null}
    </Modal>
  )
}

export default VehicleMapModal
